import React from 'react';
import { finalOrganizeItems } from '../data/offer';
import { images } from '../data/links';
import { SectionCta } from './SectionCta';
export function FinalCta() {
  return <section className="w-full bg-ink px-5 py-16 sm:py-24" aria-labelledby="final-title" data-id="element-108" data-mp="19ez2ffcjrc38">
      <div className="mx-auto max-w-5xl" data-id="element-109" data-mp="19cmdujcaa3h7">
        <div className="mx-auto max-w-3xl text-center" data-id="element-110" data-mp="15car910d1t33">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-gold sm:text-sm" data-id="element-111" data-mp="1jd52dresm85g">Ready?</p>
          <h2 id="final-title" className="mt-3 font-heading text-[1.9rem] font-semibold leading-tight text-white sm:text-4xl lg:text-[2.75rem]" data-id="element-112" data-mp="1ee1ulz7fhnts">
            Ready to Organize Pediatric Praxis Cases With a Clearer Process?
          </h2>
          <p className="mt-4 text-[1.05rem] leading-relaxed text-white/80 sm:text-lg" data-id="element-113" data-mp="1o4wif80bovhc">
            You don’t need another enormous collection of theory. You need a practical way to organize:
          </p>
        </div>

        <ul className="mx-auto mt-10 max-w-3xl" data-id="element-114" data-mp="1x64gboyxfuaw">
          {finalOrganizeItems.map(item => <li key={item.label} className="border-t border-white/15 py-5 sm:grid sm:grid-cols-[1fr_1.3fr] sm:gap-8" data-id="element-115" data-mp="n75nbv0pkj4p">
              <p className="font-heading text-xl font-semibold text-gold" data-id="element-116" data-mp="s6rzs28ppvcg">{item.label}</p>
              <p className="mt-1 leading-relaxed text-white/80 sm:mt-0" data-id="element-117" data-mp="x2h2geg13scz">{item.text}</p>
            </li>)}
        </ul>

        <img src={images.mockup} alt="The complete Praxis & Motor Planning Clinical Pathway bundle" className="mx-auto mt-10 w-full max-w-xl" data-id="element-118" data-mp="164gltdein8j3" />

        <div className="mx-auto mt-8 max-w-xl text-center" data-id="element-119" data-mp="1b2i5o0jrnbvm">
          <p className="text-lg leading-relaxed text-white/85" data-id="element-120" data-mp="1fua04m61m1r1">
            Six premium volumes. More than 30 practical decision tools. Five professional bonuses. One structured
            educational framework.
          </p>
          <p className="mt-6 font-heading text-3xl font-semibold text-white sm:text-4xl" data-id="element-121" data-mp="1pt8xh8lcyayq">
            Get Instant Access Today for Just <span className="text-gold" data-id="element-122" data-mp="1tuknhf858y7g">$27</span>
          </p>
        </div>
        <SectionCta tone="dark" label="Get the Praxis & Motor Planning Clinical Pathway™" data-id="element-123" data-mp="3qvqjxw9ht4mf" />
      </div>
    </section>;
}